/*
 * Collection ?q= enhancement — Reformation. When a collection page has a ?q=
 * param, AI-rank the grid. Loaded only by the collection product-grid section.
 *
 * Same surgical model as /search: swap only #product-grid's items so the
 * facets sidebar + column class survive; bail to native when a filter.* param
 * is active (native owns faceting). Fail-soft: null/zero results leave the
 * native collection grid intact.
 */
(function () {
  function reveal() { try { if (window.__aiSwapReveal) window.__aiSwapReveal(); } catch (e) {} }
  if (!window.AISearchClient || !window.AISearchClient.ready()) { reveal(); return; }
  var params = new URLSearchParams(window.location.search);
  var q = (params.get('q') || '').trim();
  if (q.length < 2) { reveal(); return; }

  var hasFilter = false;
  params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
  if (hasFilter) { reveal(); return; }

  var container = document.getElementById('ProductGridContainer');
  if (!container) { reveal(); return; }

  window.AISearchClient.query(q)
    .then(function (data) {
      if (!data) { reveal(); return; }
      var total = (data.products || []).length + (data.articles || []).length;
      try { if (window.AISearchAnalytics) window.AISearchAnalytics.logSearch(q, total, 'collection'); } catch (e) {}
      if (total === 0) { reveal(); return; } // no AI matches → native collection grid stays
      window.AISearchClient.applyResults(data, 'collection', q)
        .then(function (patched) {
          if (patched) { reveal(); return; }
          var cols = parseInt(container.getAttribute('data-ai-columns'), 10) || 4;
          window.AISearchClient.renderGridContainer(data, 'collection', q, cols)
            .then(function (html) { container.innerHTML = html; reveal(); }, reveal);
        }, reveal);
    })
    .catch(reveal);
})();
